import React from 'react';
import AnimateIn from './AnimateIn';
import './FeatureSection.css';

const defaultFeatures = [
  {
    id: 1,
    icon: 'target',
    title: 'Practical First',
    description: 'Learn by doing. Our curriculum focuses on real-world scenarios and hands-on projects rather than just theory.',
  },
  {
    id: 2,
    icon: 'briefcase',
    title: 'Industry Aligned',
    description: 'Curriculum designed with input from top tech companies to ensure you learn exactly what employers are looking for.',
  },
  {
    id: 3,
    icon: 'community',
    title: 'Community Driven',
    description: 'Grow alongside peers, mentors, and industry experts in a supportive environment that fosters collaboration.',
  },
];

const IconTarget = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

const IconBriefcase = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);

const IconCommunity = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const getIcon = (icon) => {
  switch (icon) {
    case 'target':
      return <IconTarget />;
    case 'briefcase':
      return <IconBriefcase />;
    case 'community':
      return <IconCommunity />;
    default:
      return <IconTarget />;
  }
};

const FeatureSection = ({ features, sectionHeading }) => {
  const list = features && features.length > 0 ? features : defaultFeatures;

  return (
    <section className="feature-section" id="features">
      <div className="feature-section-container">
        {sectionHeading && (
          <h2 className="feature-section-heading">{sectionHeading}</h2>
        )}
        <div className="feature-section-grid">
          {list.map((item, i) => (
            <AnimateIn
              key={item.id}
              direction={i % 2 === 0 ? 'left' : 'right'}
              delay={i * 120}
              className="feature-card"
            >
              <div className="feature-card-icon-wrap">
                <span className="feature-card-icon">{getIcon(item.icon)}</span>
              </div>
              <h3 className="feature-card-title">{item.title}</h3>
              <p className="feature-card-description">{item.description}</p>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
